import type { ContentTypePropertyConfig } from './flotiq-client/types/api-response';

import {
  BlockIcon,
  CheckboxIcon,
  DateIcon,
  EmailIcon,
  GeoIcon,
  ListIcon,
  MarkdownIcon,
  MediaIcon,
  NumberIcon,
  RadioIcon,
  RelationIcon,
  RichTextIcon,
  SelectIcon,
  SimpleListIcon,
  TextareaIcon,
  TextIcon,
} from '../images/shapes';

export const ICONS = {
  block: <BlockIcon />,
  checkbox: <CheckboxIcon />,
  dateTime: <DateIcon />,
  email: <EmailIcon />,
  geo: <GeoIcon />,
  object: <ListIcon />,
  textMarkdown: <MarkdownIcon />,
  media: <MediaIcon />,
  number: <NumberIcon />,
  radio: <RadioIcon />,
  datasource: <RelationIcon />,
  richtext: <RichTextIcon />,
  select: <SelectIcon />,
  text: <TextIcon />,
  textarea: <TextareaIcon />,
  simpleList: <SimpleListIcon />,
};

export const findIcon = (fieldProps?: ContentTypePropertyConfig) => {
  if (!fieldProps) return <></>;
  const isMedia =
    fieldProps.inputType === 'datasource' &&
    fieldProps.validation?.relationContenttype === '_media';
  const key = isMedia ? 'media' : fieldProps.inputType;
  return key in ICONS ? ICONS[key as keyof typeof ICONS] : <></>;
};
